<template>
  <div v-loading="loading"
    element-loading-text="拼命加载中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)">
    <div class="main recharge">
      <div class="noauth"  v-if="!DepositRight"  style="padding-top:30px;padding-left:20px;font-size:24px;">暂无充值权限</div>
      <div  v-if="DepositRight">
        <div class="heard">
        我要充值
      </div>
      <div class="allow-pay-time" v-if="!IsRemark">
        <div v-show="payChannleModel.ForbidHolidayPay || payChannleModel.AllowPayTime">
          {{payChannleModel.Name}}: 允许支付时间范围
          <span>{{payChannleModel.ForbidHolidayPay ? "工作日" : ""}} </span>
          <span v-show="payChannleModel.AllowPayTime"> {{payChannleModel.AllowPayTime}}</span>
        </div>
      </div>
      <div class="conter" style="margin-top: 20px;">
        <div style="margin: 20px 0px;width:90%;padding-left: 98px;" class="clearfix" v-show="isPayChannel">
          <el-radio v-model="radio" border :label="index + ''" v-for="(item,index) in PayChannellist" :key="index" @change="GetExchangeRate(item.Code,0)"> <span class="PayChanneltext">{{item.Name}}</span> </el-radio>
        </div> 
        <el-form :label-position="labelPosition" label-width="100px" :model="formLabelAlign" style="margin-bottom:30px">
          <el-form-item label="充值账户：">
            <el-input v-model="formLabelAlign.name" disabled="" size="small" style="width:500px;margin-left:-200px;"></el-input>
          </el-form-item>
          <el-form-item label="汇率：">
            <el-input v-model="this.ExchangeRate" disabled="" style="width:500px;margin-left:-200px;" size="small"></el-input>
          </el-form-item>
          <el-form-item label="手续费：">
            <el-input v-model="this.commission" disabled="" style="width:500px;margin-left:-200px;" size="small"></el-input>
            <!-- <span class="dw">人民币</span> -->
          </el-form-item>
          <el-form-item label="收款账户：" v-show="IsRemark">
            <div  class="gotolink"  @click="gotootherpage()"  v-if="InsUserMoneyInHelpLink!=''">请联系管理员</div>
            <el-select v-model="formLabelAlign.PaymentAccountType" clearable placeholder="请选择账户类型" style="margin-left: -260px;" @change="getAccountList()">
              <el-option
                v-for="item in PaymentAccountTypeList"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
            <el-select :value-key="formLabelAlign.PaymentAccountType == 1 ? 'ID' : 'Id'" v-model="formLabelAlign.PaymentAccountInfo" clearable placeholder="请选择账户" @change="changeAccountFn()">
              <el-option
                v-for="item in PaymentAccountList"
                :key="formLabelAlign.PaymentAccountType == 1 ? item.ID : item.Id"
                :label="formLabelAlign.PaymentAccountType == 1 ? item.BankName + '-' + item.CardUserName  : item.UserName"
                :value="item">
              </el-option>
            </el-select>
          </el-form-item>
          <template v-if="IsRemark">
            <p style="margin-top:-20px;margin-left:-490px;font-size:14px;color:red">手续费为 {{commission}} 元</p>
          </template>
          <el-form-item :label="RandomMoney ? '意向金额：' : '充值金额：'">
            <el-input v-model="formLabelAlign.intention" placeholder="请输入" :disabled="textmoney"  @keyup.native="showrandomlist()" style="width:500px;margin-left:-200px;" size="small"></el-input>
            <!-- <span class="dw">{{RechargeInputAmountType == "USD" ? "美元" : "人民币"}}</span> -->
            <span class="dw">{{Payunit}}</span>
          </el-form-item>
          <template v-if="!IsRemark">
            <p style="margin-top:-20px;margin-left:-490px;font-size:12px;color:red">
              <span v-show="(MinimumUSD != 0 && MinimumCNY != 0) || (MaximumUSD != 0 && MaximumCNY != 0)">
                注:
                <span v-show="MinimumUSD != 0 && MinimumCNY != 0">
                  最小金额为{{RechargeInputAmountType == "USD" ? MinimumUSD : MinimumCNY}}{{RechargeInputAmountType == "USD" ? "美元" : "元"}}
                </span>&nbsp;
                <span v-show="MaximumUSD != 0 && MaximumCNY != 0">
                  最大金额为{{RechargeInputAmountType == "USD" ? MaximumUSD : MaximumCNY}}{{RechargeInputAmountType == "USD" ? "美元" : "元"}}
                </span>
              </span>
            </p>
          </template>
          <!-- <template v-if="IsRemark">
            <p style="margin-top:-20px;margin-left:-490px;font-size:12px;color:red">注:最小金额为{{RechargeInputAmountType == "USD" ? MinimumUSD : MinimumCNY}}{{RechargeInputAmountType == "USD" ? "美元" : "元"}}</p>
          </template> -->
          <el-form-item label="充值金额：" v-show="isfiexdmoney">
            <!-- <el-input v-model="this.LocalMoneyFact" disabled="" style="width:500px;margin-left:-200px;" size="small" @propertychange="RemarkInfo()"></el-input>
            <span class="dw">人民币</span> -->
              <div id="moneyboxs" v-show="isfiexdmoney">
                  <a href="javascript:;" class="money" @click="rechargemoney(item,index)" v-for="(item,index) in fixesmoney" :key="index">{{item}}</a>                
              </div> 
          </el-form-item>
          <p style="margin-top:-20px;margin-left:-470px;font-size:12px;color:red" v-show="isfiexdmoney">注:请选择一个随机金额</p>
          <el-form-item label="支付金额：" v-show="RechargeInputAmountType == 'USD' && formLabelAlign.PaymentAccountType != 4">
            <el-input v-model="this.LocalMoney" disabled="" style="width:500px;margin-left:-200px;" size="small"></el-input>
            <span class="dw">人民币</span>
          </el-form-item> 
          <el-form-item label="入账金额：">
            <el-input v-model="this.TransferMoneyFact" disabled="" style="width:500px;margin-left:-200px;" size="small"></el-input>
            <span class="dw">{{CurrencyName}}</span>
          </el-form-item> 
          <el-form-item label="充值方式："  v-show="PayChannellist.length">
            <el-radio-group v-model="radio3" style="margin-left:-470px" @change="setchecked()">
              <el-radio label="1">在线充值</el-radio>
              <el-radio label="2" v-show="!isCanUseWallet">汇款申请</el-radio>
            </el-radio-group>
          </el-form-item>
          
          <el-form-item label="备注信息：" v-show="IsRemark">
            <el-input v-model="formLabelAlign.Remark" placeholder="备注格式(建议)：姓名:XXX"  style="width:500px;margin-left:-200px;" size="small"></el-input>
          </el-form-item>
        </el-form>
        <el-button type="primary" class="btn rechargebtn" @click="preorder()" style="font-size:20px">立即充值</el-button>
        <el-checkbox v-model="checked" v-if="showcheckbox" @change="handleCheckedCitiesChange">一分钱测试</el-checkbox>       
        <!-- 离线充值成功弹窗 -->
        <el-dialog title="线下充值申请成功，请完成转账！" @close="closeDialog()" @opened="dialogOpened()"  style="z-index:2006;overflow:auto;"   :visible.sync="dialogVisible" width="40%" :close-on-click-modal="false">
          <div class="offlineInfo">
            <p class="title">申请金额： <span style="color:red;">{{OLocalMoneyFact}}</span>  
          {{Payunit}}</p>  
          <!-- <p class="title">申请金额： <span style="color:red;">{{this.formLabelAlign.PaymentAccountType == 4?TransferMoneyFact : OLocalMoneyFact}}</span>  
          {{Payunit}}</p>    -->
          <p class="title" style="word-break:break-word;">订单编号：{{OrderID}}</p>  
          <p class="title" style="word-break:break-word;">实付：{{LocalMoneyFacts}}</p>  
         
          <p>备付金账户信息：</p>
           <!-- <ul>
             <li>账户名称：{{bankname}}</li>
             <li>银行名称：{{bankzhihang}}</li>
             <li>银行卡号：{{bankno}}</li>
           </ul> -->
           <ul v-show="formLabelAlign.PaymentAccountType == 1">
             <li>账户名称：{{formLabelAlign.PaymentAccountInfo.CardUserName}}</li>
             <li>银行名称：{{formLabelAlign.PaymentAccountInfo.BankName}}</li>
             <li>银行卡号：{{formLabelAlign.PaymentAccountInfo.CardNO}}</li>
             <li>省份：{{formLabelAlign.PaymentAccountInfo.ProvinceName}}</li>
             <li>城市：{{formLabelAlign.PaymentAccountInfo.CityName}}</li>
             <li>支行信息：{{formLabelAlign.PaymentAccountInfo.SubbranchName}}</li>
           </ul>
           <ul v-show="formLabelAlign.PaymentAccountType == 2">
             <li>真实姓名：{{formLabelAlign.PaymentAccountInfo.UserName}}</li>
             <!-- <li>联系方式：{{formLabelAlign.PaymentAccountInfo.Phone}}</li> -->
             <li>微信昵称：{{formLabelAlign.PaymentAccountInfo.Nickname}}</li>
             <li><div title="二维码" id="wechatQrcode" style="width: 400px;margin: 0 auto 20px;"><img :src="'data:image/png;base64,' + (formLabelAlign.PaymentAccountInfo.QrCode || '')" alt="" width="100%"></div></li>
           </ul>
           <ul v-show="formLabelAlign.PaymentAccountType == 3">
             <li>真实姓名：{{formLabelAlign.PaymentAccountInfo.UserName}}</li>
             <!-- <li>联系方式：{{formLabelAlign.PaymentAccountInfo.Phone}}</li> -->
             <li>支付宝昵称：{{formLabelAlign.PaymentAccountInfo.Nickname}}</li>
             <li><div title="二维码" id="alipayQrcode" style="width: 400px;margin: 0 auto 20px;"><img :src="'data:image/png;base64,' + (formLabelAlign.PaymentAccountInfo.QrCode || '')" alt="" width="100%"></div></li>
           </ul>
           <ul v-show="formLabelAlign.PaymentAccountType == 4">
             <li>USDT收款码：{{formLabelAlign.PaymentAccountInfo.Account}}</li>
             <li><div title="二维码" id="alipayQrcode" style="width: 400px;margin: 0 auto 20px;"><img :src="'data:image/png;base64,' + (formLabelAlign.PaymentAccountInfo.QrCode || '')" alt="" width="100%"></div></li>
           </ul>
           <ul v-show="formLabelAlign.PaymentAccountType == 5">
             <li>真实姓名：{{formLabelAlign.PaymentAccountInfo.UserName}}</li>
             <li>云闪付昵称：{{formLabelAlign.PaymentAccountInfo.Nickname}}</li>
             <li>云闪付收款码：{{formLabelAlign.PaymentAccountInfo.Account}}</li>
             <li><div title="二维码" id="alipayQrcode" style="width: 400px;margin: 0 auto 20px;"><img :src="'data:image/png;base64,' + (formLabelAlign.PaymentAccountInfo.QrCode || '')" alt="" width="100%"></div></li>
           </ul>
           <ul v-show="formLabelAlign.PaymentAccountType == 6">
             <li>真实姓名：{{formLabelAlign.PaymentAccountInfo.UserName}}</li>
             <li>收款码昵称：{{formLabelAlign.PaymentAccountInfo.Nickname}}</li>
             <li>其他收款码：{{formLabelAlign.PaymentAccountInfo.Account}}</li>
             <li><div title="二维码" id="alipayQrcode" style="width: 400px;margin: 0 auto 20px;"><img :src="'data:image/png;base64,' + (formLabelAlign.PaymentAccountInfo.QrCode || '')" alt="" width="100%"></div></li>
           </ul>
          <div class="notes" id="hint" v-html="remitHintHtml">
            <!-- <p style="text-align: center">加载中...</p> -->
            <!-- <p>注意事项提示</p>
            <p>汇款要求： 汇款时，请务必使用本人账户打款，否则资金无法到账；</p> 
            <p>汇款提示： 汇款时，请将上方的订单号加入汇款备注中，以便我们快速的帮忙您处理； </p>
            <p>到账时间： 收到款项后2小时内会帮你入金，如果超过2小时未到账，请联系客服人员；  </p>
            <p>汇款时间： 汇款转账时间为工作日早9:00—17:00，其他时间段不接受汇款形式入金请选择在线充值。 </p>
            <p>如果您已经完成汇款，请点击确定按钮。</p>             -->
          </div>

        </div>
          <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
          </span>
        </el-dialog>
        <!-- 支付成功弹窗         -->
        <el-dialog title="提示" :visible.sync="dialogVisible1" width="20%" :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false">
          <span>下单成功,点击确定跳转支付页面！</span>
          <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="skipPay()">确 定</el-button>
          </span>
        </el-dialog>
      </div>
    </div>
    <wallet ref="wallet"></wallet>
      </div>
      
  </div>
</template>

<script>
import "../assets/lib/jquery.min.js";
import "../assets/lib/jquery.qrcode.min.js";
import config from "../../static/config.json";
import { setTimeout, clearTimeout } from 'timers';
import wallet from "@/components/modification/wallet.vue";
export default {
  name: "Recharge",
  components: {
    wallet
  },
  data() {
    return {
      radio: "0",
      radio1: "",
      radio2: "",
      Apay: "",
      radio3: "1",
      radio4: "",
      greenyep:false,
      bfpay:false,
      PayUrl: "",
      PayUrl1: "",
      checked: "",
      checkbox: "",
      showcheckbox: "",
      remitHintHtml: "<p>加载中...</p>",
      textmoney: false,
      loading: false,
      IsRemark: false,
      lixian:false,
      dialogVisible:false,
      dialogVisible1: false,
      labelPosition: "right",
      OrderID:"",
      LocalMoneyFacts:"",
      commission: "0",
      ExchangeRate: 0,
      LocalMoneyFact: 0.0,
      OLocalMoneyFact:0,
      TransferMoneyFact: 0,
      TransferMoney: 0,
      preorderdata: {},
      PaymentAccountList: [], // 收款账户列表
      PaymentAccountTypeList: [{ // 收款账户类型
        label: "银行卡",
        value: 1
      },
      {
        label: "USDT",
        value: 4
      },
      {
        label: "微信",
        value: 2
      },
      {
        label: "支付宝",
        value: 3
      },
      {
           value: 5,
          label: "云闪付"
        },
        {
           value: 6,
           label: "其他"
        }
      ],
      LocalMoney: "",
      LocalMoneyFee: "",
      InsCode: "",
      Sign: "",
      OrderID: "",
      userInfo:{},
      formLabelAlign: {
        name: "",
        intention: "",
        PayChannel: "",
        PaymentAccountType: "",
        PaymentAccountInfo: "",
        Remark: ""
      },
      bankname:"",
      bankzhihang:"",
      bankno:"",
      ccbpay:false,
      PayChannellist:[],
      isfiexdmoney:false,
      fixesmoney:[],
      reqTimer: 0,
      realmoney:0,
      isPayChannel:true,
      RechargeInputAmountType: "",
      RechargeInputAmountTypeInit: "",
      payQueryUrl: "",
      RandomMoney: true,
      MinimumCNY: 1,
      MinimumUSD: 1,
      MaximumCNY: 49900,
      MaximumUSD: 6849,
      Terminal: 0,
      OfflineRandomAccount: false,
      payChannleModel: {}, // 当前所选支付渠道信息, 用于展示
      isCanUseWallet: false, // 是否可使用钱包功能
      CurrencyName: '',
      InsUserMoneyInHelpLink:'',
      DepositRight:false,
      Payunit:''
    };
  },
  watch:{
      // 'radio': function (v) {
      //    this.GetExchangeRate();
      // },
  },
  mounted() {

    if (sessionStorage.getItem("remitHint") == null || sessionStorage.getItem("remitHint") == "undefined" || sessionStorage.getItem("remitHint") == undefined || sessionStorage.getItem("remitHint") == '""') { 
        var remitHint = "<p>注意事项提示:</p>" +
              "<p>汇款要求： 汇款时，请务必使用本人名下账户打款，否则资金无法到账；</p>" +
              "<p>汇款提示： 汇款时，请将上方的订单号加入汇款备注中，以便我们快速的帮忙您处理； </p>" +
              "<p>到账时间： 收到款项后2小时内会帮你入金，如果超过2小时未到账，请联系客服人员； </p>" +
              "<p>汇款时间： 汇款转账时间为工作日早9:00—17:00，其他时间段不接受汇款形式入金请选择在线充值。 </p>" +
              "<p>如果您已经完成汇款，请点击关闭按钮。</p>";
        this.remitHintHtml = remitHint;
      } else {
        var remitHint = JSON.parse(sessionStorage.getItem("remitHint"));
        this.remitHintHtml = remitHint;
      }

      this.InsUserMoneyInHelpLink=JSON.parse(sessionStorage.getItem('insTestProp'))['InsUserMoneyInHelpLink'];
  },
  created() {
    // window.addEventListener('pageshow', () => {
        
    // })
    this.userInfo = JSON.parse(sessionStorage.getItem('userInfo'));
    
    if (sessionStorage.getItem("RechargeInputAmountType") == null || sessionStorage.getItem("RechargeInputAmountType") == "undefined") {
      this.RechargeInputAmountType = "USD";
    } else {
      this.RechargeInputAmountType = JSON.parse(sessionStorage.getItem("RechargeInputAmountType"));
    }
    this.RechargeInputAmountTypeInit = this.RechargeInputAmountType;

    /**
     * 支付通道配置读取接口，不再使用项目里配置（config.json）
     * 2020年6月10日
     * qdy
     */

    // console.log(this.RechargeInputAmountType);
    if (sessionStorage.getItem("OfflineRandomAccount") == null || sessionStorage.getItem("OfflineRandomAccount") == "undefined" || sessionStorage.getItem("OfflineRandomAccount") == "") {
    } else {
      this.OfflineRandomAccount = JSON.parse(sessionStorage.getItem("OfflineRandomAccount"));
    }

    this.formLabelAlign.name = sessionStorage.getItem("uname");
    this.PayUrl = sessionStorage.getItem("payurl");
    this.PayUrl = this.PayUrl.substring(1, this.PayUrl.length - 1);
    this.checkbox = sessionStorage.getItem("showcheckbox");
    if (this.checkbox == "true") {
      this.showcheckbox = true;
    }
    this.QryUserRight();
    this.GetInsChannels();
    this.getUserIsSupportWallet();
    this.queryrandommoney();
    this.getCurrencyName();
    
  },
  methods: {

    //获取当前页面权限
    QryUserRight() {
      var url = "/User/QryUserRight";
      var post = "";
      this.$loginapi.post(url, post, response => {
        if (response.Ret == 0) {
            
            this.DepositRight=response.Data.DepositRight;
        } else {
          this.$alert(response.Msg, {});
        }
      });
    },

    gotootherpage(){

        window.open(this.InsUserMoneyInHelpLink)
    },
    getCurrencyName() {
      var url = "/Account/GetInsBasicCurrency";
      var post = "";
      this.$loginapi.post(url, post, response => {
        if (response.Ret == 0) {
          this.CurrencyName = response.Data.Name;
        } else {
          this.$alert(response.Msg, {});
        }
      });
    },
    // 获取用户是否支持有钱钱包功能
    getUserIsSupportWallet () {
      let url = "/Wallet/CanUseWallet";
      let postData = "";
      this.$loginapi.post(url, postData, response => {
        if (response.Ret == 0) {
          this.isCanUseWallet = response.Data;
        } else {
          // this.$message.error(response.Msg);
        }
      });
    },
    queryrandommoney(){
      // 生成默认随机金额
      let min = 200;
      let max = 1000;
      let randlist = [];
      let str = this.formLabelAlign.intention;
      var unit = "元";
      if (this.RechargeInputAmountType == "USD") {
        unit = "美元";
      }
      for(var i=0;i<=10;i++){
        let n = this.randomNum(min,max)
        if(randlist.indexOf(n) == -1 && str != n){
          randlist.push(n);
        }                 
        if(randlist.length == 5){
            randlist.sort();
            randlist.sort(function (m, n) {
            if (m < n) return -1
            else if (m > n) return 1
            else return 0
            });
            this.fixesmoney = randlist;
            for(let k = 0 ; k<this.fixesmoney.length;k++){
              this.fixesmoney[k] = this.fixesmoney[k] + unit;
            }
           this.fiexdmoney();                   
           return;
        }
      }
    },
    //获取账户可用充值通道
    GetInsChannels() {
      let url = "/PayChannel/GetInsChannels";
      this.$loginapi.post(url, "", response => {
        if (response.Ret == 0) {
          var dataArr = response.Data;
         
          dataArr.forEach( obj => {
            if (obj.Terminal == 0 || obj.Terminal == 1){
              this.PayChannellist.push(obj);
            }
          });
          // console.log(this.PayChannellist);
          
          if(this.PayChannellist.length == 0){
              /**
               * 没有支付渠道时, 默认显示离线充值, 隐藏一分钱测试, 隐藏充值方式切换按钮
               * 2019年10月9日10:11:18
               * qdy
               */
              // this.$message.warning("没有支付通道，请联系管理员");
              this.radio3 = "2";
              this.showcheckbox = false;
              this.textmoney = true;
              // this.getExchangeRateFn();
              this.formLabelAlign.intention = this.realmoney;
              if(this.formLabelAlign.intention == "" || this.formLabelAlign.intention == 0){
                    this.formLabelAlign.intention = null
              }else{
                this.queryExchangeRate();
              }    
              this.textmoney = false;
              this.IsRemark = true;
              this.lixian = true;
              this.commission = 0;
              this.TransferMoneyFact = 0;
              this.isfiexdmoney = false;
              this.isPayChannel = false; 
              this.QryInfo();
              return;
          }
          if(this.PayChannellist.length <= 1){
              this.isPayChannel = false;
          }
          this.formLabelAlign.PayChannel = this.PayChannellist[0].Code;
          this.GetExchangeRate(this.formLabelAlign.PayChannel);
        } else {
          this.$message.error(response.Msg);
        }
      });
    },
    // 获取汇率手续费信息
    GetExchangeRate(code,type) { 
       if(type == 0){
         this.formLabelAlign.PayChannel = code;
         this.formLabelAlign.intention = 0;
         this.realmoney = 0;
         this.LocalMoney = 0;
         this.TransferMoney = 0;
         this.LocalMoneyFact = 0;
         this.TransferMoneyFact = 0;
         this.ExchangeRate = 0;
         this.commission = 0;
         this.queryrandommoney();  
       }
       /**
        * 2019年12月7日14:16:29
        * 当前选择渠道信息
        */
       for (var obj in this.PayChannellist) {
         if (this.PayChannellist[obj].Code === this.formLabelAlign.PayChannel) {
            this.payChannleModel = JSON.parse(JSON.stringify(this.PayChannellist[obj]));
         }
       }


        if(!this.IsRemark){
        this.RandomMoney = this.payChannleModel.RandomMoney;
        this.MinimumCNY = this.payChannleModel.SingleMinLimitCNY;
        this.MinimumUSD = this.payChannleModel.SingleMinLimitUSD;
        this.MaximumCNY = this.payChannleModel.SingleLimitCNY;
        this.MaximumUSD = this.payChannleModel.SingleLimitUSD;
        this.Terminal = this.payChannleModel.Terminal;
        }
       // 隐藏随机金额
        this.isfiexdmoney = this.RandomMoney;
        if (this.realmoney == '') {
          return;
        }
      //  setTimeout(()=>{
          let url = "/Account/CreatePrePayPreview";
          let data = {
            Money: this.realmoney,
            PayChannel: this.formLabelAlign.PayChannel,
            MoneyType: "CNY"
          };
          if (this.RechargeInputAmountType == "USD") {
            data.MoneyType = "";
          }
          if(data.Money == ""){
            data.Money = 0;
          }
          this.$loginapi.post(url, data, response => {
            if (response.Ret == 0) {
              this.preorderdata = response.Data;
              this.ExchangeRate = this.preorderdata.ExchangeRate;
              this.commission = this.preorderdata.LocalMoneyFee;
              this.LocalMoney = this.preorderdata.LocalMoney;
              this.TransferMoney = this.preorderdata.TransferMoney;
              this.LocalMoneyFact = this.preorderdata.LocalMoneyFact;
              this.TransferMoneyFact = this.preorderdata.TransferMoneyFact;
              if (!this.RandomMoney) {
                if (this.RechargeInputAmountType == "USD") {
                  this.formLabelAlign.intention = response.Data.TransferMoney;
                } else {
                  this.formLabelAlign.intention = response.Data.LocalMoney;
                }
              }
            } else {
              this.$message.error(response.Msg);
              return;
          }
          });
      //  },500)      
    },
    getExchangeRateFn() { // 获取汇率
      var url = "/Account/GetExchangeRate";
      this.$loginapi.post(url, {}, response => {
            this.ExchangeRate = response;
      });
    },
    // 创建预下单
    preorder() {
      // this.querybank();
      // 如果选中测试进入测试支付
      if (this.checked == true) {
        // this.dialogVisible1 = true;
        let url = "/Account/CreatePrePayPreviewForTest";
        let data = {
          PayChannel: this.formLabelAlign.PayChannel
        };
        this.$loginapi.post(url, data, response => {
          if (response.Ret == 0) {
            // console.log(response.Data)
            this.preorderdata = response.Data;
            this.PrePay();
            // console.log(this.preorderdata)
          } else {
            this.$message.error(response.Msg);
          }
        });
        return;
      }
      if (this.radio3 == 1) {
        // 正式支付在线充值
        if(this.PayChannellist.length == 0){
            this.$message.warning("没有支付通道，请联系客服人员");
            return;
        }
        if (this.realmoney == "") {
          this.$message.error("充值金额信息有误！");
          return;
        }

        if (this.RechargeInputAmountType == "USD") {
          if (this.MaximumUSD != 0) {
            if(this.realmoney > this.MaximumUSD){
              this.$message.error("单笔金额不能超出" + this.MaximumUSD + "1美元");
              return;
            }
          }
          if(this.realmoney <　this.MinimumUSD && this.realmoney > 0){
            this.$message.error("单笔金额不能低于" + this.MinimumUSD + "美元");
            return;
          }
          if (this.LocalMoneyFact == 0) {
            this.$message.error("支付金额有误");
            return;
          }
        } else {
          if (this.MaximumCNY != 0) {
            if(this.realmoney > this.MaximumCNY){
              this.$message.error("单笔金额不能超出" + this.MaximumCNY + "元");
              return;
            }
          }
          if(this.realmoney < this.MinimumCNY && this.realmoney > 0){
            this.$message.error("单笔金额不能低于" + this.MinimumCNY + "元");
            return;
          }
          if (this.TransferMoneyFact == 0) {
            this.$message.error("入账金额有误");
            return;
          }
        }
        let url = "/Account/CreatePrePayPreview";
        let data = {
          Money: this.realmoney,
          PayChannel: this.formLabelAlign.PayChannel,
          MoneyType: "CNY"
        };
        if (this.RechargeInputAmountType == "USD") {
            data.MoneyType = "";
          }
        this.$loginapi.post(url, data, response => {
          if (response.Ret == 0) {
            this.preorderdata = response.Data;
            this.PrePay();
            // this.dialogVisible1 = true;
            // this.GetExchangeRate();
          } else {
            this.$message.error(response.Msg);
            return;
          }
        });
      } else if (this.radio3 == 2) {
        // 正式支付离线充值
        if (this.formLabelAlign.intention == "" || this.formLabelAlign.intention == null || this.formLabelAlign.intention == 0) {
          this.$message.error("充值金额信息有误！");
          return;
        }
        if (this.formLabelAlign.PaymentAccountType == null || this.formLabelAlign.PaymentAccountType == "") {
          this.$message.error("请选择收款账户！");
          return;
        }
        if (this.formLabelAlign.PaymentAccountInfo == null || this.formLabelAlign.PaymentAccountInfo == "") {
          this.$message.error("请选择收款账户！");
          return;
        }
        if (this.LocalMoneyFact == 0) {
          this.$message.error("支付金额有误");
          return;
        }
        if (this.RechargeInputAmountType == "USD") {
            if(this.formLabelAlign.intention < 1 && this.formLabelAlign.intention > 0){
                this.$message.error("单笔金额不能低于1美元");
                return;
              }
          } else {
            if(this.formLabelAlign.intention < 1 && this.formLabelAlign.intention > 0){
              this.$message.error("单笔金额不能低于1元");
              return;
            }
          }
        // this.formLabelAlign.Remark = "用户名：" + this.userInfo.UserName + "；" + " 充值账户： " + this.formLabelAlign.name +  "；" +" 支付金额： " + this.LocalMoneyFact
        let url = "/Account/PayApply";
        let data = {
          Money: this.formLabelAlign.intention,
          MoneyType: "CNY",
          Remark: this.formLabelAlign.Remark,
          PaymentAccountType: this.formLabelAlign.PaymentAccountType,
          PaymentAccountId: this.formLabelAlign.PaymentAccountInfo.Id || this.formLabelAlign.PaymentAccountInfo.ID
        };
        if (this.RechargeInputAmountType == "USD") {
          data.MoneyType = "";
        }
        this.$loginapi.post(url, data, response => {
          if (response.Ret == 0) {
            this.OrderID = response.Data.OrderNo;
            this.LocalMoneyFacts=response.Data.LocalMoneyFact;
            this.OLocalMoneyFact = this.LocalMoney;
            this.dialogVisible = true;
            this.$message.success("离线充值已申请，请等待审核");
            this.realmoney = "";
            this.formLabelAlign.intention = "";
            this.LocalMoney = 0;
            this.LocalMoneyFact = 0;
            // this.formLabelAlign.Remark = "用户名：" + this.userInfo.UserName + "；" + " 充值账户： " + this.formLabelAlign.name +  "；" +" 支付金额： " + this.LocalMoneyFact;
          } else {
            this.$message.error(response.Msg);
            return;
          }
        });
      }
    },
    dialogOpened() {
      
      // if (this.formLabelAlign.PaymentAccountType == 1) { // 银行卡
      //   return;
      // }
      // console.log($("#wechatQrcode"));
      // if (this.formLabelAlign.PaymentAccountType == 2) { // 微信
      //   var url = this.formLabelAlign.PaymentAccountInfo.QrCodeRaw || "HTTPS://QR.ALIPAY.COM/FKX02130DDYOKIGOECLU67";
      //   $("#wechatQrcode").qrcode(url)
      // } else if (this.formLabelAlign.PaymentAccountType == 3) { // 支付宝
      //   var url = this.formLabelAlign.PaymentAccountInfo.QrCodeRaw || "HTTPS://QR.ALIPAY.COM/FKX02130DDYOKIGOECLU67";
      //   $("#alipayQrcode").qrcode(url)
      // }
    },
    closeDialog() {
      // $("#wechatQrcode").empty()
      // $("#alipayQrcode").empty()
     },
    // 测试充值赋值页面
    handleCheckedCitiesChange() {
      if (this.checked == true) {
        this.textmoney = true;
        this.realmoney = "0.01";
        this.LocalMoneyFact= "0.01";  
      } else {
        this.textmoney = false;
        this.realmoney = "";
        this.LocalMoneyFact= "";  
      }
    },
    //获取离线充值配置信息
    QryInfo(){
        let RechargeConfig = JSON.parse(sessionStorage.getItem('RechargeConfig'));
        this.RandomMoney = RechargeConfig[0].RandomMoney;
        this.MinimumCNY = RechargeConfig[0].MinimumCNY;
        this.MinimumUSD = RechargeConfig[0].MinimumUSD;
        this.MaximumCNY = RechargeConfig[0].MaximumCNY;
        this.MaximumUSD = RechargeConfig[0].MaximumUSD;
        this.Terminal = RechargeConfig[0].Terminal; 
    },
    // 在线离线充值切换
    setchecked() {
      //离线
      if (this.radio3 == 2) {
        // this.getExchangeRateFn();
        this.formLabelAlign.intention = this.realmoney;
        if(this.formLabelAlign.intention == "" || this.formLabelAlign.intention == 0){
              this.formLabelAlign.intention = null
        }else{
          this.queryExchangeRate();
        }    
        this.textmoney = false;
        // this.formLabelAlign.Remark = "用户名：" + this.userInfo.UserName + "；" + " 充值账户： " + this.formLabelAlign.name +  "；" +" 支付金额： " + this.LocalMoneyFact
        this.IsRemark = true;
        this.lixian = true;
        this.commission = 0;
        this.TransferMoneyFact = 0;
        this.isfiexdmoney = false;
        this.isPayChannel = false;
        this.QryInfo();
      } else {
        this.commission = 0;
        if(this.formLabelAlign.PayChannel == ""){
          this.$message.warning("没有支付通道，请联系客服人员");
          this.textmoney = true;
        }else{
          this.realmoney = 0;
          this.formLabelAlign.intention = null;
          this.GetExchangeRate(this.formLabelAlign.PayChannel);          
        }
        $("#moneyboxs").find("a").css("border-color","#ccc");
        this.showrandomlist();
        this.LocalMoneyFact = 0;
        this.TransferMoneyFact = 0;
        this.IsRemark = false;
        this.lixian = false;
        if(this.PayChannellist.length > 1){
          this.isPayChannel = true;
        }
      }
    },
    // 获取汇率用于离线充值
    queryExchangeRate(){
          // if (this.RechargeInputAmountType == "USD") {
          //   if(this.formLabelAlign.intention > this.MaximumUSD){
          //     this.$message.error("单笔金额不能超出" + this.MaximumUSD + "美元");
          //     // this.formLabelAlign.intention = 0;
          //     // this.LocalMoneyFact = 0;
          //     return;
          //   }
          //   if(this.formLabelAlign.intention < this.MinimumUSD && this.formLabelAlign.intention > 0){
          //     this.$message.error("单笔金额不能低于" + this.MinimumUSD + "美元");
          //     // this.formLabelAlign.intention = 0;
          //     // this.LocalMoneyFact = 0;
          //     return;
          //   }
          // } else {     
          //   if(this.formLabelAlign.intention > this.MaximumCNY){
          //     this.$message.error("单笔金额不能超出" + this.MaximumCNY + "元");
          //     // this.formLabelAlign.intention = 0;
          //     // this.TransferMoneyFact = 0;
          //     return;
          //   }
          //   if(this.formLabelAlign.intention < this.MinimumCNY && this.formLabelAlign.intention > 0){
          //     this.$message.error("单笔金额不能低于" + this.MinimumCNY + "元");
          //     // this.formLabelAlign.intention = 0;
          //     // this.TransferMoneyFact = 0;
          //     return;
          //   }
          // }
          if (this.formLabelAlign.PaymentAccountType === '' || this.formLabelAlign.PaymentAccountInfo === '') {
            this.$message.error("请选择收款账户");
            return;
          }
          if (this.formLabelAlign.intention == '' || this.formLabelAlign.intention == null) {
            return;
          }
          // console.log(this.formLabelAlign.PaymentAccountInfo);
          let url = "/Account/PrePayApplyView";
          var postData = {
            Money: this.formLabelAlign.intention,
            PaymentAccountType: this.formLabelAlign.PaymentAccountType,
            PaymentAccountId: this.formLabelAlign.PaymentAccountInfo.Id || this.formLabelAlign.PaymentAccountInfo.ID,
            MoneyType: "CNY"
          }
          if (this.RechargeInputAmountType == "USD") {
            postData.MoneyType = "";
          }
          this.$loginapi.post(url, postData, response => {
            if (response.Ret == 0) {
              this.LocalMoney = response.Data.LocalMoney;
              this.TransferMoney = response.Data.TransferMoney;
              this.LocalMoneyFact = response.Data.LocalMoneyFact;
              this.TransferMoneyFact = response.Data.TransferMoneyFact;
              this.ExchangeRate = response.Data.ExchangeRate;
              this.commission = response.Data.LocalMoneyFee;
              /**
               * 用户输入金额按照服务端返回值为准, 防止网速问题下页面数据混乱
               * 2019年8月15日10:11:35
               * qdy
               */
              if(this.formLabelAlign.PaymentAccountType==4){
                this.formLabelAlign.intention=response.Data.LocalMoney;
              }else{
                  if (this.RechargeInputAmountType == "USD") {
                this.formLabelAlign.intention = response.Data.TransferMoney;
              } else {
                this.formLabelAlign.intention = response.Data.LocalMoney;
              }
              }
              
              // this.formLabelAlign.Remark = "用户名：" + this.userInfo.UserName + "；" + " 充值账户： " + this.formLabelAlign.name +  "；" +" 支付金额： " + this.LocalMoneyFact
            } else {
              this.$message.error(response.Msg);
              return;
          }
          });     
    },
    // 离线充值金额

    // 充值预下单
    PrePay() {
      let url = "/Account/PrePay";
      let data = this.preorderdata;
      // var tempwindow = window.open(); //先打开临时窗体，由于是点击事件内触发，不会被拦截
      if (this.formLabelAlign.PayChannel == 'yilianpayh5') {
        this.$alert("对不起，此渠道换汇额度已满，暂时不可用！");
        return;
      }
      this.$loginapi.post(url, data, response => {
        if (response.Ret == 0) {
          // console.log(response)
          this.OrderID = response.Data.OrderID;
          this.LocalMoney = response.Data.LocalMoney;
          this.LocalMoneyFee = response.Data.LocalMoneyFee;
          this.InsCode = response.Data.InsCode;
          this.Sign = response.Data.Sign;
          var Attach = 2;
          /**
           * Attach
           * 原本默认为2
           * 支付方式选择yilianpayh5的时候  Attach字段   PC端传2   APP端传1
           */
          if (this.formLabelAlign.PayChannel == 'yilianpayh5') {
            Attach = 2;
          }
          var query = "?";
          query += "OriginalOrderCode=" + this.OrderID + "&";
          query += "Amount=" + this.LocalMoney + "&";
          query += "Fee=" + this.LocalMoneyFee + "&";
          query += "PayChannel=" + this.formLabelAlign.PayChannel + "&";
          query += "InsCode=" + this.InsCode + "&";
          query += "Sign=" + this.Sign + "&";
          query += "Attach=" + Attach;
           if(response.Data.UserKey != null){
           query += "&UserKey=" + response.Data.UserKey;
          }
         this.payQueryUrl = this.PayUrl + query;
         if (this.formLabelAlign.PayChannel == 'yilianpayh5') {
            let url = "/Wallet/QryWalletOpenResult";
            let postData = "";
            this.$loginapi.post(url, postData, response => {
              if (response.Ret == 0) {
                if(response.Data.IsOpen) { // 已经开通有钱钱包
                  this.dialogVisible1 = true;
                } else { // 未开通有钱钱包
                  this.$alert("未开通有钱钱包功能，是否去开通有钱钱包?", "", {
                    showCancelButton: true,
                    confirmButtonText: "开通",
                    callback: action => {
                      if (action == "confirm") {
                        // this.$refs.wallet.WalletOpenAccountPre();
                        this.openWallet();
                      }
                    }
                  });
                }
              } else {
              }
            });
          } else {
            this.dialogVisible1 = true;
          }
          // tempwindow.location = this.PayUrl + query; //当回调的时候更改临时窗体的路径
          // this.dialogVisible1 = false;
          // this.formLabelAlign.intention = "";
          // this.LocalMoneyFact = "";
          // this.isfiexdmoney = true;
          // this.realmoney = 0;
          // this.GetExchangeRate();
        } else {
          this.$message.error(response.Msg);
        }
      });
    },
    openWallet () {
      let url = "/Wallet/AuthOper";
      let postData =  {
        OperType: 'real',
        Source: 2
      };
      this.loading = true;
      this.$loginapi.post(url, postData, response => {
        this.loading = false;
        if (response.Ret == 0) {
          window.open(response.Data)
        } else {
          this.$message.error(response.Msg);
        }
      });
    },
    skipPay() {
      window.open(this.payQueryUrl); //当回调的时候更改临时窗体的路径
      this.dialogVisible1 = false;
      this.formLabelAlign.intention = "";
      this.LocalMoneyFact = "";
      this.isfiexdmoney = true;
      this.realmoney = 0;
      this.GetExchangeRate();
    },
    setmoney() {
      this.formLabelAlign.intention = String(this.formLabelAlign.intention);
      this.formLabelAlign.intention = this.formLabelAlign.intention.replace(
        /[^\d^\.]+/g,
        ""
      );
      this.formLabelAlign.intention = this.formLabelAlign.intention.replace(
        /\b(0+)/gi,
        ""
      );
      if (Number(this.formLabelAlign.intention) < 1) {
        //  this.$message.warning("最小金额为1美元！");
        this.formLabelAlign.intention = "";
      }
      if (this.formLabelAlign.intention.indexOf(".") != -1) {
        this.formLabelAlign.intention = Number(this.formLabelAlign.intention);
        if (isNaN(parseInt(this.formLabelAlign.intention))) {
          //  this.$message.warning("请输入一个正确的金额！");
          this.formLabelAlign.intention = "";
        }
        this.formLabelAlign.intention = this.num(this.formLabelAlign.intention, 2);
      }
      // 计算支付金额
      this.LocalMoneyFact = (
        this.formLabelAlign.intention / this.ExchangeRate
      ).toFixed(2);
      // this.formLabelAlign.Remark = "用户名：" + this.userInfo.UserName + "；" + " 充值账户： " + this.formLabelAlign.name +  "；" +" 支付金额： " + this.LocalMoneyFact
    },
    num(digit, length) {
      length = length ? parseInt(length) : 0;
      if (length <= 0) return Math.round(digit);
      digit = Math.round(digit * Math.pow(10, length)) / Math.pow(10, length);
      return digit;
    },
    querybank(){
        let url = "/Account/GetBankAccountByInsId";
        this.$loginapi.post(url, "", response => {
          if (response.Ret == 0) {
            if(response.Data == null || response.Data.length == 0){
              this.$message.warning("后台未配置银行卡收款账户，请联系客服人员");
              return;
            }else{
              this.PaymentAccountList = response.Data;
              if (this.OfflineRandomAccount) {
                var random = Math.floor(Math.random() * this.PaymentAccountList.length);
                this.PaymentAccountList = [this.PaymentAccountList[random]];
                this.formLabelAlign.PaymentAccountInfo = this.PaymentAccountList[0];
                this.queryExchangeRate();
              }
              // this.bankname = response.Data.CardUserName;   
              // this.bankzhihang = response.Data.BankName;   
              // this.bankno = response.Data.CardNO;               
            } 
          } else {
            this.$message.error(response.Msg);
            return;
          }
        });
    },
    getAccountList() { // 根据账户类型获取账号列表
      this.PaymentAccountList = [];
      this.formLabelAlign.PaymentAccountInfo = "";
      if (this.formLabelAlign.PaymentAccountType == "" || this.formLabelAlign.PaymentAccountType == null) {
        return;
      }
      if (this.formLabelAlign.PaymentAccountType == 4) { // USDT
        this.RechargeInputAmountType = "USD";
      }else {
        this.RechargeInputAmountType = this.RechargeInputAmountTypeInit;
      }
      if (this.formLabelAlign.PaymentAccountType == 1) { // 银行卡
        this.querybank();
      } else if (this.formLabelAlign.PaymentAccountType == 2) { // 微信
        this.queryQrcode(0);
      } else if (this.formLabelAlign.PaymentAccountType == 3) { // 支付宝
        this.queryQrcode(1);
      } else if (this.formLabelAlign.PaymentAccountType == 4) { // USDT
        this.queryQrcode(2);
      }else if (this.formLabelAlign.PaymentAccountType == 5) { // 云闪付
        this.queryQrcode(3);
      }else if (this.formLabelAlign.PaymentAccountType == 6) { // 其他
        this.queryQrcode(4);
      }
    },
    changeAccountFn () {
      if (this.formLabelAlign.PaymentAccountInfo) {
        // console.log("request");
        this.Payunit=this.formLabelAlign.PaymentAccountInfo.Unit
        this.queryExchangeRate();
      }
    },
    queryQrcode(type){ // 获取微信二维码
        let url = "/Account/GetQrCodeAccountByInsId";
        var data = type; // 0 微信, 1 支付宝
        this.$loginapi.post(url, data, response => {
          if (response.Ret == 0) {
            if (response.Data == null || response.Data.length == 0) {
              if (type == 0) {
                this.$message.warning("后台未配置微信收款账户，请联系客服人员");
                return;
              } else if (type == 1) {
                this.$message.warning("后台未配置支付宝收款账户，请联系客服人员");
                return;
              } else if (type == 2) {
                this.$message.warning("后台未配置USDT收款账户，请联系客服人员");
                return;
              }else if (type == 3) {
                this.$message.warning("后台未配置云闪付收款账户，请联系客服人员");
                return;
              }else if (type == 4) {
                this.$message.warning("后台未配置其他收款账户，请联系客服人员");
                return;
              }
            } else {
              this.PaymentAccountList = response.Data;
              if (this.OfflineRandomAccount) {
                var random = Math.floor(Math.random() * this.PaymentAccountList.length);
                this.PaymentAccountList = [this.PaymentAccountList[random]];
                this.formLabelAlign.PaymentAccountInfo = this.PaymentAccountList[0];
                this.queryExchangeRate();
              }
            }
          } else {
            this.$message.error(response.Msg);
            return;
          }
        });
    },
    fiexdmoney(){
       this.isfiexdmoney = true;
    },
    nofiexdmoney(){
       this.isfiexdmoney = false;
    },
    rechargemoney(n,index){ 
       if (this.RechargeInputAmountType == "USD") {
         n = n.substring(0,n.length - 2);
       } else {
         n = n.substring(0,n.length - 1);
       }
       this.realmoney = n;
      //  this.isfiexdmoney = false;
       this.GetExchangeRate();
       $("#moneyboxs").find("a").css("border-color","#ccc");
       $("#moneyboxs").find("a").eq(index).css("border-color","#337ab7");
    },
    // 展示随机金额
    showrandomlist(){ 
      console.log(this.formLabelAlign.intention)
     
            if(this.radio3 == 2){ //离线
              if(this.formLabelAlign.intention == "" || this.formLabelAlign.intention == 0){
                this.commission = 0;
                this.ExchangeRate = 0;
                this.LocalMoneyFact = 0;
                this.TransferMoneyFact = 0;
                return;
              }
              /**
               * 用户输入完600毫秒后请求, 减少请求次数
               */
              clearTimeout(this.reqTimer);
              this.reqTimer = setTimeout(() => {
                this.queryExchangeRate();
              }, 600);
              
              return;
            }
            if(this.PayChannellist.length == 0){
                this.$message.warning("暂不支持在线充值, 请使用离线充值.");
                return;
            }               
                this.formLabelAlign.intention = Number(this.formLabelAlign.intention);
                if(isNaN(this.formLabelAlign.intention)){        
                    this.formLabelAlign.intention = "";
                    
                    return;
                }
                if (this.formLabelAlign.intention == '') {
                  this.commission = 0;
                  this.ExchangeRate = 0;
                  this.LocalMoneyFact = 0;
                  this.TransferMoneyFact = 0;
                }    

                // if (this.RechargeInputAmountType == "USD") {
                //   if(this.formLabelAlign.intention > this.MaximumUSD){
                //     this.$message.error("单笔金额不能超出" + this.MaximumUSD + "美元");
                //     this.LocalMoneyFact = 0;
                //     return;
                //   }
                //   if(this.formLabelAlign.intention < this.MinimumUSD && this.formLabelAlign.intention > 0){
                //     this.$message.error("单笔金额不能低于" + this.MinimumUSD + "美元");
                //     this.LocalMoneyFact = 0;
                //     return;
                //   }
                // } else {     
                //   if(this.formLabelAlign.intention > this.MaximumCNY){
                //     this.$message.error("单笔金额不能超出" + this.MaximumCNY + "元");
                //     this.TransferMoneyFact = 0;
                //     return;
                //   }
                //   if(this.formLabelAlign.intention < this.MinimumCNY && this.formLabelAlign.intention > 0){
                //     this.$message.error("单笔金额不能低于" + this.MinimumCNY + "元");
                //     this.TransferMoneyFact = 0;
                //     return;
                //   }
                // }

                if (!this.RandomMoney) {
                  this.realmoney = this.formLabelAlign.intention;
                  clearTimeout(this.reqTimer);
                  this.reqTimer = setTimeout(() => {
                    this.GetExchangeRate();
                  }, 600);
                  return;
                }

                if(this.formLabelAlign.intention == 0 || this.formLabelAlign.intention == ""){
                  this.LocalMoneyFact = 0;
                  this.TransferMoneyFact = 0;
                  this.queryrandommoney();
                  this.formLabelAlign.intention = "";
                  return;
                }
                if(this.formLabelAlign.intention > 10){
                  let min = this.formLabelAlign.intention - 10;
                  let max = this.formLabelAlign.intention + 10;
                  let randlist = [];
                  let str = this.formLabelAlign.intention;
                  var unit = "元";
                  if (this.RechargeInputAmountType == "USD" ) {
                    unit = "美元";
                  }
                  for(var i=0;i<=10;i++){
                    let n = this.randomNum(min,max)
                    if(randlist.indexOf(n) == -1 && str != n){
                      randlist.push(n);
                    }                 
                    if(randlist.length == 5){
                      randlist.sort();
                      randlist.sort(function (m, n) {
                      if (m < n) return -1
                      else if (m > n) return 1
                      else return 0
                      });
                      this.fixesmoney = randlist;
                      for(let k = 0 ; k<this.fixesmoney.length;k++){
                        this.fixesmoney[k] = this.fixesmoney[k] + unit;
                      }                     
                      this.fiexdmoney();
                      this.realmoney = 0;
                      this.GetExchangeRate();                      
                      return;
                    }
                  }               
                }else{
                  this.realmoney = this.formLabelAlign.intention;
                  this.GetExchangeRate();
                }

    },
    // 生成随机金额
    randomNum(minNum,maxNum){ 
        switch(arguments.length){ 
        case 1: 
        return parseInt(Math.random()*minNum+1,10); 
        break; 
        case 2: 
        return parseInt(Math.random()*(maxNum-minNum+1)+minNum,10); 
        break; 
        default: 
        return 0; 
        break; 
        } 
    } 
  }
};
</script>

<style lang="less">
/* .offlineInfo{
  position: absolute;
  right: 250px;
  top: 230px;
} */
.recharge .allow-pay-time {
  text-align: center;
  font-size: 18px;
  line-height: 30px;
  margin-top: 10px;
}
.recharge .allow-pay-time span {
  color: red;
}
.recharge .offlineInfo .title{
      border-bottom: 1px solid #999;
    margin-left: 0;
    text-align: left;
    margin-bottom: 20px;
    line-height: 40px;
}
.recharge .offlineInfo p{
  margin-left: 0;
  text-align: left;
}
.recharge .offlineInfo li{
    text-align: left;
    line-height: 40px;
    border-bottom: 1px dashed #ccc;
    margin-bottom: 15px;
    word-break: break-word;
}
.recharge .notes p{
  color: red;
}
.recharge .home-container {
    height: 100%;
    overflow: auto;
}
.recharge .conter {
    margin-bottom: 50px;
}
.recharge .PayChanneltext{
  font-size: 25px;
  color: #000;
  display: inline-block;
  padding: 0 10px;
  font-family: cursive;
  font-weight: 700;
}
.recharge .fixedmoney{
  width: 62.5%;
  height: 130px;
  position: absolute;
  border: 1px solid #ccc;
  border-radius: 10px;
  background-color: #fff;
  z-index: 9;
  padding: 20px;
    a{
      float: left;
      padding: 0 10px;
      border: 1px solid #ccc;
      margin-right: 20px;
      border-radius: 5px;
      margin-bottom: 10px;
    }
    .clearstyle{
      position: absolute;
      right: 10px;
      top: 0px;
      padding: 0;
      margin: 0;
      border: 0;
    }
    .active{
       border-color: red;
    }
}
.recharge #moneyboxs{
  text-align: left;
  a{
      float: left;
      padding: 0 10px;
      border: 1px solid #ccc;
      margin-right: 20px;
      border-radius: 5px;
      margin-bottom: 10px;
      text-decoration:none;
    }
}

.gotolink{

  position: absolute;
  right: 124px;
  bottom: 0;
  color: #409EFF;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/Recharge.vue